import * as React from 'react';
import styles from './index.less';
import { Input, InputRef } from 'antd';
import {
  ChangeEventHandler,
  CompositionEventHandler,
  FocusEventHandler,
  KeyboardEventHandler,
} from 'react';
import { FUtil } from '@freelog/tools-lib';

export interface FSingleLineInputProps {
  value: string;
  placeholder?: string;
  className?: string;
  hasError?: boolean;
  size?: 'small' | 'middle';
  style?: React.CSSProperties;
  // FI18n.i18nNext.t('form_input_singlelinetxt_error_length')
  lengthLimit?: number;

  onChangeValue?(value: string): void;

  onChange?: ChangeEventHandler<HTMLInputElement>;
  onPressEnter?: KeyboardEventHandler<HTMLInputElement>;
  onKeyUp?: KeyboardEventHandler<HTMLInputElement>;
  disabled?: boolean;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  autoFocus?: boolean;
  // onCompositionStart?: CompositionEventHandler<HTMLInputElement>;
  // onCompositionEnd?: CompositionEventHandler<HTMLInputElement>;
}

function FSingleLineInput(
  {
    autoFocus = false,
    disabled = false,
    value,
    placeholder = '',
    className = '',
    hasError = false,
    size = 'middle',
    style = {},
    lengthLimit = 100,
    onChange,
    onPressEnter,
    onKeyUp,
    onBlur,
    onChangeValue,
  }: // onCompositionStart,
  // onCompositionEnd,
  FSingleLineInputProps,
  ref: React.Ref<InputRef> | undefined,
) {
  const [$flag, set$flag, get$flag] = FUtil.Hook.useGetState<boolean>(true);
  const [$value, set$value, get$value] = FUtil.Hook.useGetState<string>('');

  React.useEffect(() => {
    if (value !== get$value()) {
      set$value(value);
    }
  }, [value]);

  return (
    <Input
      autoFocus={autoFocus}
      disabled={disabled}
      value={$value}
      ref={ref}
      placeholder={placeholder}
      className={[
        className,
        disabled ? styles.disabledInput : styles.Input,
        hasError ? styles.InputError : '',
      ].join(' ')}
      style={{
        height: size === 'middle' ? 38 : 32,
        ...style,
      }}
      onPressEnter={onPressEnter}
      onKeyUp={onKeyUp}
      onChange={(event) => {
        // console.log(get$flag(), 'CCCCCCCCCCCCCCCCC');
        if (get$flag()) {
          onChangeValue && onChangeValue(event.target.value);
        }
        set$value(event.target.value);
      }}
      suffix={
        lengthLimit > 0 ? (
          <span
            className={[
              styles.FInputWordCount,
              lengthLimit - value.length < 0 ? styles.beyond : '',
            ].join(' ')}
          >
            {lengthLimit - value.length}
          </span>
        ) : undefined
      }
      onBlur={onBlur}
      onCompositionStart={(event) => {
        // console.log(event, '************************** event');
        set$flag(false);
      }}
      onCompositionEnd={(event: any) => {
        // console.log(event, '############################## event');
        set$flag(true);
        onChangeValue && onChangeValue(event.target.value as string);
      }}
    />
  );
}

export default React.forwardRef(FSingleLineInput);
